'use client';

import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { Icon } from 'src/general/Icons/Icon';
import { Button } from 'src/general/components/Button/Button';
import { plpFilterModalStore } from 'src/stores/plpFilterModalStore';

/**
 * Trigger for the filters modal on PLP
 */
export const PlpFiltersTrigger: FC = () => {
  const { setOpen } = plpFilterModalStore(
    (state) => ({
      setOpen: state.setOpen,
    }),
    shallow,
  );

  return (
    <Button
      variant="secondary"
      size="small"
      onClick={() => setOpen(true)}
      endIcon={<Icon name="filter" />}
      data-testid={`MobileSearch-component-filterButton`}
    >
      Filters
    </Button>
  );
};
